import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46cce8bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chapter-list" }
const _hoisted_2 = { class: "touch-dom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" 章节列表 "),
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" 加载骨架屏 "),
      ($setup.loading)
        ? (_openBlock(), _createBlock($setup["listSkeleton"], { key: 0 }))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(['chapter-list-box', { block: $setup.config.viewType === 'list' }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (i, k) => {
              return (_openBlock(), _createBlock($setup["chapter"], {
                key: k,
                "view-type": $setup.config.viewType,
                chapterInfo: i,
                onClick: ($event: any) => ($setup.go_browse(i)),
                onContextmenu: _withModifiers(($event: any) => ($setup.context_menu(i, k)), ["prevent"])
              }, null, 8 /* PROPS */, ["view-type", "chapterInfo", "onClick", "onContextmenu"]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */))
    ]),
    _createCommentVNode("分页组件"),
    _createVNode($setup["mediaPager"], {
      ref: "pager",
      page: $setup.page,
      count: $setup.count,
      "page-size-config": $setup.pageSizes,
      onPageChange: $setup.page_change
    }, null, 8 /* PROPS */, ["page", "count", "page-size-config"]),
    _createCommentVNode("功能菜单"),
    _createVNode($setup["rightSidebar"], {
      info: $setup.chapterInfo,
      menuPoster: $setup.menuPoster,
      onReload: $setup.page_change
    }, null, 8 /* PROPS */, ["info", "menuPoster"])
  ]))
}